import { encryptData } from "./Functions";
import { protectedApi } from "./protectedApi";
import { APIS } from "../constants/apiConstant";

export async function sendInvoiceEmail({ pdfBlob, pdfFileName, timesheetPdfs = [], ...metadata }) {
  const formData = new FormData();
  formData.append("file", pdfBlob, pdfFileName || "invoice.pdf");

  (Array.isArray(timesheetPdfs) ? timesheetPdfs : []).forEach(({ blob, fileName }) => {
    if (blob) {
      formData.append("timesheets", blob, fileName || "timesheet.pdf");
    }
  });

  formData.append(
    "payload",
    encryptData({
      ...metadata,
      timesheetFileNames: (Array.isArray(timesheetPdfs) ? timesheetPdfs : []).map(
        (item) => item.fileName || "timesheet.pdf"
      ),
    })
  );

  const response = await protectedApi({
    url: APIS.INVOICE_SEND_EMAIL,
    method: "POST",
    data: formData,
  });
  return response?.data;
}
